import React, { useEffect, useState } from "react";
import { Slide } from "react-reveal";
import Count from "../Counter/Counter";
import Header from "../Header/Header";
import MiniMoose from "../images/108-pn7ummemiaiwrt5guq2edmyhph7ukr39ll7cg2a5l4.webp";
import { FaRegGem } from "react-icons/fa";

import { CONFIG } from "./../../../config";

import { toast, ToastContainer } from "react-toastify";

import Web3 from "web3/dist/web3.min.js";
import { useMoralis } from "react-moralis";
import { ABI } from "./ABIs";

import "./HeroSection.css";
const HeroSection = () => {
  const [supply, setSupply] = useState(0);
  const [selcVal, setSelcVal] = useState(null);
  const [chainId, setChainId] = useState(null);

  const MintCount = [1, 2];

  const { Moralis, isWeb3Enabled, isWeb3EnableLoading } = useMoralis();

  // TOASTIFY REALTED FUNCTIONS

  const notifySuccess = (message) =>
    toast.success(message, {
      position: "bottom-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "dark",
    });
  const notifyInfo = (message) =>
    toast.info(message, {
      position: "bottom-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "dark",
    });
  const notifyError = (message) =>
    toast.error(message, {
      position: "bottom-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "dark",
    });

  // TOASTIFY REALTED FUNCTIONS

  useEffect(() => {
    const run = async () => {
      try {
        await Moralis.enableWeb3();
        let web3 = new Web3(Moralis.provider);
        let c = await web3.eth.net.getId();
        setChainId(c);
        const readOptions = {
          contractAddress: CONFIG.smart_contract_minimoose,
          functionName: "totalSupply",
          abi: ABI.totalSupply,
        };

        let message = await Moralis.executeFunction(readOptions);
        message = parseInt(message._hex, 16);
        setSupply(message);
      } catch (err) {
        console.log(err);
      }
    };
    if (!isWeb3EnableLoading && !isWeb3Enabled) {
      run();
    }
  }, [isWeb3EnableLoading, isWeb3Enabled]);

  function getNetworkName(chainID) {
    let networks = {
      1: "eth",
      4: "rinkeby",
    };
    return networks[chainID];
  }

  const mintMini = async (value) => {
    if (getNetworkName(chainId) === CONFIG.chainID) {
      if (value === 1 || value === 2) {
        const etherValue = value * 0.075;

        let options = {
          abi: ABI.mintMiniMoose,
          functionName: "mintMiniMoose",
          chain: CONFIG.chainID,
          contractAddress: CONFIG.smart_contract_minimoose,
          params: {
            _count: value,
          },
          msgValue: Moralis.Units.ETH(etherValue),
        };
        try {
          const mintTransaction = await Moralis.executeFunction(options);
          console.log(
            "mintTransaction : ",
            mintTransaction,
            "mintTransactionhash : ",
            mintTransaction.hash
          );
          // toastify #1
          notifyInfo("Please wait for confirmation");

          await mintTransaction.wait();

          // toastify #2
          notifySuccess("Your NFT is minted successfully");
        } catch (err) {
          console.log("mintError=>", err);

          if (err?.message?.includes("Exceeds maximum supply of Mini Moose ")) {
            notifyError("Maximum supply of Mini Moose reached.");
          } else if (
            err?.message?.includes(
              "Minimum 1 Mini Moose has to be minted per transaction"
            )
          ) {
            notifyError("Please select atleast 1 Mini Moose");
          } else if (err?.message?.includes("the contract is paused")) {
            notifyError("Minting is Paused at the moment");
          } else if (
            err?.message?.includes(
              "Maximum 2 Mini Moose can be minted per transaction"
            )
          ) {
            notifyError("Maximum 2 Mini Moose can be minted per transaction");
          } else if (err?.message?.includes("Not an existing holder")) {
            notifyError("Not an existing holder OG Moose");
          } else {
            // toastify #3
            notifyError("There is some error Please Try Again Later");
          }
        }
      } else {
        notifyError("Please select a value");
      }
    } else {
      let str = "REQUIRED NETWORK";
      if (CONFIG.chainID === "eth" || CONFIG.chainID === "rinkeby") {
        str = CONFIG.chainID === "eth" ? "ETH MAINNET" : "ETH RINKEBY";
      }
      notifyInfo(`Please change your network to ${str}`);
    }
  };

  return (
    <div>
      <div className="bg">
        <Header></Header>
        <ToastContainer
          position="bottom-right"
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          theme="dark"
          pauseOnHover
        />
        <hr className="border-custom" />
        <div className="backgroundMINIMoose"></div>

        <div className="hero  min-h-screen  lg:px-28 sm:px-0 text-white">
          <div className="flex justify-center max-w-8xl gap-x-10 p-4 flex-col md:flex-row-reverse mt-10">
            <Slide bottom>
              <div className="moose-Card">
                <img
                  alt="hero alpha"
                  src={MiniMoose}
                  className=" lg:max-w-sm   rounded-lg shadow-2xl moose-image"
                />
              </div>
            </Slide>
            <div className="sm:w-full lg:w-3/5">
              <div>
                <h1 className="text-4xl lg:text-7xl font-bold ">
                  Mini Moose!{" "}
                </h1>
                <div className="h-8 w-28 bg-warning  particle"></div>
              </div>

              <p className="py-6 pr-10 text-lg">
                These Mini Moose might be adorable, but they bite. Become a
                Moose Society Holder, Stake 2 for 90 days and get one FREE. Or,
                you can mint one below. There's a limited amount of Mini's
                available to mint so act quick!
              </p>
              <div className="sm:block lg:flex items-center gap-x-4  ">
                <button
                  onClick={() => mintMini(selcVal)}
                  className="btn-mint-mini dashboard px-10 py-5  h-12 flex items-center justify-center gap-x-2 font-bold"
                >
                  MINT-A-MINI <FaRegGem />
                </button>
                <div className="form-control py-2  text-center">
                  <select
                    onChange={(e) => {
                      setSelcVal(Number(e.target.value));
                    }}
                    className="select  select-bordered FreeHideOutPick"
                  >
                    <option disabled value="value" selected>
                      Select
                    </option>
                    {MintCount.map((d, idx) => (
                      <option key={idx}>{d}</option>
                    ))}
                  </select>
                </div>
              </div>
              <div>
                <Count
                  Count1={supply}
                  totalCount={3000}
                  Count2={1250}
                  Count3={1250}
                ></Count>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HeroSection;
